import React from 'react';
import { Typography } from 'antd';
import styled from '@emotion/styled';

interface ColumnProps {
  textStr: any;
}

export default React.memo((props: ColumnProps) => {
  const { textStr } = props;

  return (
    <StyledTourStoryContainer>
      <Typography.Text>{textStr}</Typography.Text>
    </StyledTourStoryContainer>
  );
});

const StyledTourStoryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-weight: 600;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
